export const accionesItems = [
    //Protocolo Cero
    {
        enlace: "ProtocoloCero",
        nombre: "Protocolo Cero",
         

        accionProtocolo:[
            {
                imagen: "./img/acciones/DiaNaranja.jpeg",
                banner:[
                <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
                    <div class="carousel-inner">
                        <div class="carousel-item active">
                            <imagen src="./img/acciones/DiaNaranja/marzo_1.jpeg" class="d-block w-100" alt="..."/>
                        </div>
                     </div>
                </div>
            ],
            texto: "Protocolo de Cero Tolerancia a las conductas de acoso sexual y/o laboral y hostigamiento sexual y/o laboral del poder ejecutivo y pronunciamiento del titular de la SADER",
           
            },
        ],
    
      },
    //Día Naranja
//   {
//     enlace: "DiaNaranja",
//     nombre: "Día Naranja",
//     imagen: "./img/acciones/Naranja.png",
//     imagen2: "./img/acciones/Naranja.png",

//     accionDiaNaranja:[
//         {
//             imagen: "./img/acciones/Comite.jpg",
//             banner:[
//             <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
//                 <div class="carousel-inner">
//                     <div class="carousel-item active">
//                         <imagen src="./img/acciones/DiaNaranja/marzo_1.jpeg" class="d-block w-100" alt="..."/>
//                     </div>
//                  </div>
//             </div>
//         ],
//         texto: "El Día Naranja y la Campaña Naranja buscan movilizar a la opinión pública y a los gobiernos para emprender acciones concretas con el fin de promover y fomentar la cultura de la no violencia.",
//         carrusel:[
//                 {
//                 imagen: "../img/acciones/DiaNaranja/enero.jpg",
//                 titulo: "Enero 2023",
//                 url:"https://www.facebook.com/AgriculturaHgo?mibextid=ZbWKwL",
                
//             },
                
//                 {
//                 imagen: "../img/acciones/DiaNaranja/25febrero.jpg",
//                 titulo: "Febrero 2023",
//             },
            
//                 {
//                 imagen: "../img/acciones/DiaNaranja/comiteMarzo.jpg",
//                 titulo: "Marzo 2023",
//             },
                
//                 {
//                 imagen: "../img/acciones/DiaNaranja/abril.jpg",
//                 titulo: "Abril 2023",
            
//             },
        
//         ],
//         },
//     ],

//   },

     //Niñas y Niños de SADER
    //  {
    //     enlace: "NiñasyNiñosSADER",
    //     nombre: "Niñas y Niños SADER",
    //     imagen: "./img/acciones/NiñosSader/CardNinosSader2.jpg",
    //     imagen2: "./img/acciones/NiñosSader/CardsNinosSader.png",

    //     accionNinosSader:[
    //         {
    //             imagen: "./img/acciones/NiñosSader/marzo_1.jpg",
    //             banner:[
    //             <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
    //                 <div class="carousel-inner">
    //                     <div class="carousel-item active">
    //                         <imagen src="./img/acciones/NiñosSader/marzo_1.jpg" class="d-block w-100" alt="..."/>
    //                     </div>
    //                  </div>
    //             </div>
    //         ],
    //         texto: "Niñas y Niños de la SADER, una vez al mes pueden acudir a las instalaiones.",
    //         carrusel:[
    //                 {
    //                 imagen: "../img/acciones/NiñosSader/febrero.jpg",
    //                 titulo: "Febrero 2023",
    //                 url:"https://www.facebook.com/AgriculturaHgo?mibextid=ZbWKwL",
                    
    //             },
                    
    //                 {
    //                 imagen: "../img/acciones/NiñosSader/marzo.jpg",
    //                 titulo: "Marzo 2023",
    //             },
                
    //                 {
    //                 imagen: "../img/acciones/NiñosSader/abril.jpg",
    //                 titulo: "Abril 2023",
    //             },
                    
    //                 {
    //                 imagen: "../img/acciones/NiñosSader/28abril.jpg",
    //                 titulo: "Dia del Niño en SADER",
                
    //             },
            
    //         ],
    //         },
    //     ],
    
    
    //   },
  
];

